import { AdministratorDto } from '@/src/models/AdministratorDto';
import CommunityCommentDto from '@/src/models/CommunityCommentDto';
import CommunityPostingDto from '@/src/models/CommunityPostingDto';
import { CustomersDto } from '@/src/models/CustomersDto';

type CommunityType = 'posting' | 'comment';
type CommunityReportType = 'reception' | 'blind' | 'common';

export default class CommunityReportDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;

  // 신고 사유(기타)
  reportReason: string;

  // 신고 사유 카테고리
  communityReportReasonType: string;

  // 신고 사유 카테고리 한글
  communityReportReasonTypeKr: string;

  // 신고 유형 (게시글 | 댓글)
  communityType: CommunityType;

  // 신고 상태
  communityReportType: CommunityReportType;

  // 신고 상태
  communityBlindStatusType: string;

  // 신고한 사용자 정보
  customer: CustomersDto;

  // 신고한 게시글 정보
  communityPosting?: CommunityPostingDto;

  // 신고한 댓글 정보
  communityComment?: CommunityCommentDto;

  // 신고 처링 일시
  reportHandledAt?: string;

  // 신고 처리 사유
  reportHandlingReason: string;

  // 처리 관리자
  administrator: AdministratorDto;
}
